<div class="spinner-wrapper" *ngIf="showLoader">
  <mat-spinner></mat-spinner>
</div>
<div class="container design-overview-wrapper">
  <h2>location Overview</h2>
  <hr>
  <div class="breadcrumb">
    <ul class="d-flex align-items-center breadcrumb__list">
      <li class="breadcrumb__list__list-item"><a class="breadcrumb__list__list-item__link" routerLink="/home">Home</a>
      </li>
      <li class="breadcrumb__list__list-item"><a class="breadcrumb__list__list-item__link"
          routerLink="/locations">Locations</a>
      </li>
      <li class="breadcrumb__list__list-item"><a class="breadcrumb__list__list-item__link"
        >{{location?.location_id}}</a>
    </li>
    </ul>
  </div>
  <div class="design-overview-wrapper__item">
    <div class="d-flex">
      <div class="ps-3">
        <p class="design-overview-wrapper__item__title">ID</p>
        <p class="design-overview-wrapper__item__detail">{{location?.location_id}}</p>
      </div>
    </div>
  </div>

  <div class="design-overview-wrapper__item">
    <div class="d-flex">
      <div class="ps-3">
        <p class="design-overview-wrapper__item__title">Location Name</p>
        <p class="design-overview-wrapper__item__detail">{{location?.subdivision_name}}</p>
      </div>
    </div>
  </div>

  <div class="design-overview-wrapper__item">
    <div class="d-flex">
      <div class="ps-3">
        <p class="design-overview-wrapper__item__title">Street Address</p>
        <p class="design-overview-wrapper__item__detail">{{location?.street_address}}</p>
      </div>
    </div>
  </div>

  <div class="design-overview-wrapper__item">
    <div class="d-flex">
      <div class="ps-3">
        <p class="design-overview-wrapper__item__title">City</p>
        <p class="design-overview-wrapper__item__detail">{{location?.city}}</p>
      </div>
    </div>
  </div>

  <div class="design-overview-wrapper__item">
    <div class="d-flex">
      <div class="ps-3">
        <p class="design-overview-wrapper__item__title"> State</p>
        <p class="design-overview-wrapper__item__detail"> {{location?.state}}</p>
      </div>
    </div>
  </div>

  <div class="design-overview-wrapper__item">
    <div class="d-flex">
      <div class="ps-3">
        <p class="design-overview-wrapper__item__title">ZIP</p>
        <p class="design-overview-wrapper__item__detail">{{location?.zip}}</p>
      </div>
    </div>
  </div>

  <div class="design-overview-wrapper__item">
    <div class="d-flex">
      <div class="ps-3">
        <p class="design-overview-wrapper__item__title">Plan</p>
        <p class="design-overview-wrapper__item__detail">{{location?.plan_name}}</p>
      </div>
    </div>
  </div>

  <div class="d-flex my-3 me-3">
    <button mat-flat-button color="primary" type="button" [routerLink]="['/location']" data-toggle="collapse"
      data-target="#dds3" aria-expanded="false" aria-controls="dds3">
      Back To Locations
    </button>
  </div>
</div>